import { BoxProps } from '@palmetto/palmetto-components';

import { QuoteDocument } from 'types';

type RequestContractVoidFunction = () => Promise<void>;

export interface DiffErrorAlerProps {
  loadingState: LoadingState;
  errorObject: ErrorObject;
  requestVoid: RequestContractVoidFunction;
  handleToleranceExceptionModal?: (value: string) => void;
  modalCTA2Text?: string;
  /** When true, prompt for a change order (with the entered values prefilled) instead of voiding. */
  easyChangeOrder?: boolean;
  accountId?: string;
  /** The as-built values the user entered, used to prefill the change-order form. */
  formData?: CheckRequestFormData;
}

export interface ErrorObject {
  production?: {
    percentErrorDiff: number;
    errorKwH: number;
  };
  systemSize?: {
    percentErrorDiff: number;
    errorKw: number;
  };
}

export interface ConfirmObject {
  production?: {
    percentDiff: number;
    diffKwH: number;
  };
  systemSize?: {
    percentDiff: number;
    diffKw: number;
  };
  step: number;
}

export interface LoadingState {
  isChecking?: boolean;
  isVoiding: boolean;
  isUpdating?: boolean;
  isAccountLoading?: boolean;
  isCurrentContractLoading?: boolean;
  isCurrentDesignLoading?: boolean;
}

export enum Origin {
  INSTALL_PACKAGE = 'installPackageAction',
  PV_SYSTEM_TAB = 'pvSystemTab',
  ACCOUNT_VIEW = 'accountView',
}

export interface IInputFormProps {
  /**
   * The current System First Year Production Kw/H
   */
  errorObject?: ErrorObject;
  loadingState: LoadingState;
  activeQuote: QuoteDocument;
  origin: Origin;
  confirmObject?: ConfirmObject;
  onChange: () => void;
}

export interface CommonFormSectionProps extends React.PropsWithChildren {
  baseStyle?: BoxProps;
  title: string;
  description?: string | React.ReactNode;
}

export interface HeaderElementProps {
  origin?: Origin;
  accountName: string;
  errorObject?: ErrorObject;
  accountId: string;
  loadingState: LoadingState;
  requestVoid?: RequestContractVoidFunction;
  handleToleranceExceptionModal?: (value: string) => Promise<boolean>;
  easyChangeOrder?: boolean;
  formData?: CheckRequestFormData;
}

export interface CheckRequestFormData {
  systemFirstYearProductionKwh: string;
  systemSizeKw: string;
}

export interface QuoteSettings {
  maxOveragePercentage: number; //0.001
  maxProductionDecrease: number; //0.05
  maxProductionIncrease: number; //0.1
  preConAdderLimit: number; //5000
}

export interface RangeCheckProps {
  originalValue: number;
  newValue: number;
  settings?: QuoteSettings;
}

export interface FormFooterProps {
  loadingState: LoadingState;
  origin?: Origin;
  confirmObject?: ConfirmObject;
  errorObject?: ErrorObject;
}

export interface FormFooterActionProps {
  loadingState: LoadingState;
  origin?: Origin;
  confirmObject?: ConfirmObject;
  errorObject?: ErrorObject;
}

export interface CheckButtonProps {
  confirmObject?: ConfirmObject;
  loadingState: LoadingState;
  origin?: Origin;
  errorObject?: ErrorObject;
}

export interface FormSectionProps {
  errorObject?: ErrorObject;
  confirmObject?: ConfirmObject;
}
